import { PageProps } from 'utils/ts/interfaces';
import { PageTemplate } from 'components/PageTemplate';
import { ApplicationBoard } from 'components/ApplicationBoard';

export const WorkApplications = ({ param }: PageProps) => (
  <PageTemplate title="Заявки в работе">
    <ApplicationBoard status="underway" param={param} commonUrl="/application/underway" />
  </PageTemplate>
);
